import { render, staticRenderFns } from "./IntelligenceShell.vue?vue&type=template&id=bf65e89c&scoped=true"
import script from "./IntelligenceShell.vue?vue&type=script&lang=js"
export * from "./IntelligenceShell.vue?vue&type=script&lang=js"
import style0 from "./IntelligenceShell.vue?vue&type=style&index=0&id=bf65e89c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf65e89c",
  null
  
)

export default component.exports